module.exports = "/images/loader-icon.svg?4bf3791be9d2b876be41afdf0d1a8bef";